export const isTelegramWebApp = () => {
  if (typeof window === 'undefined') return false;

  try {
    const w = window;

    // Strong indicators: Telegram WebApp globals injected in the WebView
    if (w.TelegramWebviewProxy) return true;
    if (w.Telegram && w.Telegram.WebApp) return true;
    if (typeof w.TelegramWebApp !== 'undefined' || typeof w.TelegramWebView !== 'undefined') return true;

    // Referrer: links coming from t.me are a reliable indicator
    const ref = (typeof document !== 'undefined' && document.referrer) ? String(document.referrer).toLowerCase() : '';
    if (ref.includes('t.me')) return true;

    // Explicit query/hash tokens used by Telegram web integrations (exact tokens only)
    const search = (w.location && w.location.search) ? String(w.location.search).toLowerCase() : '';
    const hash = (w.location && w.location.hash) ? String(w.location.hash).toLowerCase() : '';
    if (search.includes('tgwebapp') || hash.includes('tgwebapp')) return true;

    // Do not inspect pathname for "telegram" (avoids false positives when URL path contains /Telegram...)
    // Do not rely on userAgent alone — it causes false positives.

    return false;
  } catch (e) {
    return false;
  }
};